<template>
  <div :class="$groupsStyle.enlargedContainer">
    <div :class="$groupsStyle.titleContainer">
      <div :class="$groupsStyle.titleText">{{ $t('all-groups-saboteur-votes') }}</div>
      <div :class="$groupsStyle.actionsContainer">
        <div title="Close this box" :class="$groupsStyle.closeContainer" @click="props.closeAllGroupsSaboteurVotes">
          <img :class="$groupsStyle.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$groupsStyle.bodyContainer">
      <div v-for="(group, index) in props.groups" :key="index" :class="$groupsStyle.groupContainer">
        <SaboteurVotesBox
          :saboteurVotes="group.votes"
          :saboteur="group.saboteur"
          :players="group.players"
          :isHost="props.isHost"
          :title="getGroupDisplayName(group, index, t)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
// import styles from "@/css/AllGroupsSaboteurVotesBox.module.css";
// import globalStyles from "@/css/global.module.css";
import groupsStyles from "@/css/groupsUtil.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import SaboteurVotesBox from "./SaboteurVotesBox.vue";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
// const $style = styles;
// const $globalStyle = globalStyles;
const $groupsStyle = groupsStyles;
const closeIcon = CloseIcon;

// eslint-disable-next-line
const props = defineProps({
  closeAllGroupsSaboteurVotes: {
    type: Function,
    required: true,
  },
  isHost: {
    type: Boolean,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped></style>
